import { useState } from "react";
import { useApi } from "src/api";
import { Button } from "src/elements";
import { downloadFileFromUrl } from "src/utils/downloadFile";
import { useStatusModal } from "../../../modals/StatusModal/store/hooks";

interface Props {
  fixturesGuessingId: number;
  isDisabled?: boolean;
}

export const ImagineShelvesLogsButton = ({ fixturesGuessingId, isDisabled }: Props) => {
  const { getFixturesGuessingLogsApi } = useApi();
  const { openStatusModal } = useStatusModal();

  // Loading with state, because all stores page has many logs buttons, need to show spinner only for the one button.
  const [isLoading, setIsLoading] = useState(false);

  const downloadLogs = async (logsType: "requestPath" | "responsePath" | "errorDetails") => {
    setIsLoading(true);
    const response = await getFixturesGuessingLogsApi({
      fixturesGuessingId: String(fixturesGuessingId),
    });

    if (response && response[logsType]) {
      if (logsType === "errorDetails") {
        openStatusModal({
          title: "Error details",
          content: response[logsType],
        });
      } else {
        await downloadFileFromUrl(response[logsType]);
      }
    }
    setIsLoading(false);
  };

  return (
    <Button
      color="greenSmoke"
      variant="inverted"
      dropdown={[
        { label: "Pogger request", onClick: () => downloadLogs("requestPath") },
        { label: "Pogger response", onClick: () => downloadLogs("responsePath") },
        { label: "Error details", onClick: () => downloadLogs("errorDetails") },
      ]}
      isLoading={isLoading}
      isDisabled={isDisabled}
      iconRight={{ name: "arrowDown" }}
    ></Button>
  );
};
